// RunMenu — the split Run button (Navicat-style). The main button runs
// everything, or the selection when text is selected (Ctrl+R). The ▾ caret
// opens a small menu for the rarer run modes:
//   • Run (Ctrl+R)              — all statements, or the selection (same as the
//                                 main button; listed for discoverability)
//   • Run current statement     — the statement under the cursor, or the
//     (Ctrl+Shift+R)              selection if any
//   • Run as script             — DELIMITER-aware (stored procedures/triggers)
//
// Reuses ExportMenu's dropdown styling (like ExplainMenu / FormatMenu).
//
// Props:
//   onRun()         fn — main action (run all / selection)
//   onRunCurrent()  fn — run statement under cursor / selection
//   onRunScript()   fn — run as a DELIMITER-aware script
//   disabled        bool
//   disabledReason  string — tooltip when disabled (e.g. mid-edit)
import { createSignal, Show } from 'solid-js';
import { useDismissable } from '../lib/dismissable.js';

export default function RunMenu(props) {
  const [open, setOpen] = createSignal(false);
  let btnRef, menuRef;
  useDismissable(() => [btnRef, menuRef], () => setOpen(false), { event: 'click' });

  const act = (fn) => { setOpen(false); fn?.(); };

  return (
    <div class="export-menu run-split">
      <button class="btn btn-sm run-split-main" disabled={props.disabled}
              onClick={() => props.onRun?.()}
              title={props.disabled && props.disabledReason
                ? props.disabledReason
                : 'Run all statements — or just the selection if text is selected (Ctrl+R)'}>
        ▶ Run
      </button>
      <button ref={btnRef} class="btn btn-sm run-split-caret" disabled={props.disabled}
              onClick={() => setOpen(!open())} title="More run options">▾</button>
      <Show when={open()}>
        <div ref={menuRef} class="export-menu-pop">
          <button class="export-menu-item" onClick={() => act(props.onRun)}
                  title="Run all statements, or the selection if text is selected.">
            <span>▶ Run</span><span class="export-menu-kbd">Ctrl+R</span>
          </button>
          <button class="export-menu-item" onClick={() => act(props.onRunCurrent)}
                  title="Run the statement under the cursor — or the selection if text is selected.">
            <span>▷ Run current statement</span><span class="export-menu-kbd">Ctrl+Shift+R</span>
          </button>
          <div class="export-menu-sep" />
          <button class="export-menu-item" onClick={() => act(props.onRunScript)}
                  title="Run as script — honours DELIMITER $$ … DELIMITER ; for stored procedures, triggers, and functions.">
            <span>▷ Run as script</span>
          </button>
        </div>
      </Show>
    </div>
  );
}
